import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('RequestForm.xero.XeroCreateContactPopup.AddressSection', {
    addressAttentionLabel: 'Attention',
    addressAttentionPlaceholder: 'Enter attention',
    cityLabel: 'City/town',
    cityPlaceholder: 'Enter city/town',
    addressLabel: 'Address',
    addressPlaceholder: 'Enter address',
    stateLabel: 'State/region',
    statePlaceholder: 'Enter state/region',
    postalCodeLabel: 'Postal code/ZIP code',
    postalCodePlaceholder: 'Enter postal / ZIP code',
    countryLabel: 'Country',
    countryPlaceholder: 'Enter country',
});
